class PermissionTree {

    _root = [];
    _permissions = [];
    _permissionNodes = [];


    constructor(permissions = []) {
        this.setPermissions(permissions);
    }

    setPermissions(permissions) {
        this._permissions = permissions;
        this.treenize();
        this.printTree();
        this.arrangement();
        this.printArray();
    }

    size() {
        return this._root.length;
    }

    get items() {
        return this._root;
    }

    get nodes() {
        return this._permissionNodes;
    }

    // 트리 구조의 노드를 배열로 변환합니다.
    arrangement() {
        this._root.forEach(rootNode => {
            this.insertNodeAsArray(rootNode);
        });
    }

    insertNodeAsArray(permissionNode) {
        this._permissionNodes.push(permissionNode);

        if (!permissionNode.children || permissionNode.children.length === 0) return;

        permissionNode.children.forEach(child => {
            this.insertNodeAsArray(child);
        });
    }

    treenize() {
        this._permissions.forEach(permission => {
            // 생성할 아이템이 트리상에 이미 존재하는지 여부를 검사합니다.
            const node = this.findNodeById(permission.id);
            if (!!node) return; // 이미 존재합니다. 다음진행.
            this.insertNode(new PermissionNode(permission));
        });
    }

    findPermission(id) {
        return this._permissions.find(permission => permission.id === id);
    }

    findNodeByCanonicalName(canonicalName, nodes) {
        const target = nodes || this._root;
        for (let i = 0; i < target.length; i++) {
            const node = target[i];
            if (node.canonicalName === canonicalName) return node;
            if (node.hasChildrenNode()) {
                const found = this.findNodeByCanonicalName(canonicalName, node.children); // ------------------- 리커시브 호출입니다. 주의하세요.
                if (!!found) return found;
            }
        }
        return null;
    }

    findNodeById(id, nodes) {
        const target = nodes || this._root;
        for (let i = 0; i < target.length; i++) {
            const node = target[i];
            if (node.id === id) return node;
            if (node.hasChildrenNode()) {
                const found = this.findNodeById(id, node.children); // ------------------- 리커시브 호출입니다. 주의하세요.
                if (!!found) return found;
            }
        }
        return null;
    }

    insertNode(permissionNode) {
        // 부모가 없습니다. 최상위 노드로 추가합니다.
        if (permissionNode.isRootNode()) {
            this.insertNodeAsRoot(permissionNode);
        } else {
            this.insertNodeAsChild(permissionNode);
        }
    }

    insertNodeAsRoot(node) {
        this._root.push(node);
    }

    insertNodeAsChild(node) {
        // 부모 노드에 추가하기 위해 부모 노드를 찾습니다.
        const pid = node.parentPermissionId;
        const parentNode = this.findNodeById(pid);
        // 부모 노드가 존재합니다. 부모의 자식으로 추가합니다.
        if (!!parentNode) {
            parentNode.addChildNode(node);
        }
        // 부모 노드가 없습니다. 부모를 생성해서 삽입 후 추가합니다.
        else {
            // 부모 노르로 만들 부모 퍼미션을 찾습니다.
            const permission = this.findPermission(pid);
            if (!!permission) {
                this.insertNode(new PermissionNode(permission)); // ------------------- 리커시브 호출입니다. 주의하세요.
                this.insertNode(node); // ------------------- 리커시브 호출입니다. 주의하세요.
            } else {
                // 최상위 노드입니다. 아무것도 하지 않습니다.
            }
        }
    }

    printTree() {
        this._root.forEach(node => {
            this.printNode(node, 1);
        });
    }

    printArray() {
        console.log("==================== printArray ====================");
        this.nodes.forEach(node => {
            this.printNode(node, 1);
        });
    }

    printNode(node, depth) {
        let prefix = '';
        for (let i = 0; i < depth; i++) {
            prefix += '   ';
        }
        console.log(depth + ' - ' + prefix + ':' + node.name + '(' + node.id + ') - ' + node.canonicalName);
        if (node.hasChildrenNode()) {
            node.children.forEach(child => {
                this.printNode(child, depth + 1);
            });
        }
    }
}

class PermissionNode {

    //private variables
    _permission;
    _parentNode;

    //expose variables
    id;
    name;
    children = [];

    constructor(permission) {
        this._permission = permission;
        this.id = permission.id;
        this.name = permission.name;
    }

    setParentNode(parentNode) {
        this._parentNode = parentNode;
    }

    deleted() {
        return this.permission.deleteYn === "Y"
    }

    isRootNode() {
        return this._permission.parentId === undefined || this._permission.parentId == null || this._permission.parentId === 0;
    }

    hasParentNode() {
        return !!this._parentNode;
    }

    hasChildrenNode() {
        return this.children.length > 0;
    }

    addChildNode(permissionNode) {
        this.children.push(permissionNode);
        permissionNode.setParentNode(this);
    }

    get permission() {
        return this._permission;
    }

    get parentPermissionId() {
        return this._permission.parentId;
    }

    get canonicalName() {
        let cname = this.name;
        if (this.hasParentNode()) {
            cname = this._parentNode.canonicalName + '__' + cname;
        }
        return cname;
    }

}

class PermissionManager {

    _tree;

    constructor(permissions = []) {
        this.setPermissions(permissions);
    }

    setPermissions(permissions) {
        this._tree = new PermissionTree(permissions);
    }

    hasPermission(canonicalPermissionName) {
        return this.hasPermissionByCanonicalName(canonicalPermissionName);
    }

    hasPermissionByCanonicalName(canonicalPermissionName) {
        return !!this._tree.findNodeByCanonicalName(canonicalPermissionName);
    }

    hasPermissionById(permissionId) {
        return !!this._tree.findNodeByCanonicalName(permissionId);
    }
}

const permissionManager = new PermissionManager();
export {PermissionManager, PermissionTree, PermissionNode, permissionManager}
